module.exports = __webpack_public_path__ + "static/img/02.b03f25f6.png";